export default __webpack_public_path__ + "static/media/logo.28b9df0f.png";